// 회원가입 / 프로필 입력값 검증 헬퍼

// 아이디: 영문/숫자/언더스코어 6~20자
export const USERNAME_REGEX = /^[a-zA-Z0-9_]{6,20}$/;
export const isValidUsername = (username) => USERNAME_REGEX.test((username || '').trim());

// 이름: 한글/영문/공백 2~20자 (숫자, 특수문자 불가)
export const NAME_REGEX = /^[가-힣a-zA-Z\s]{2,20}$/;
export const isValidName = (name) => NAME_REGEX.test((name || '').trim());

// 휴대폰번호: 01[0,1,6~9] + 7~8자리 숫자 (대시/공백 무시)
export const normalizePhone = (raw) => (raw || '').replace(/[^0-9]/g, '');
export const isValidPhone = (raw) => /^01[016789]\d{7,8}$/.test(normalizePhone(raw));
export const formatPhone = (raw) => {
  const d = normalizePhone(raw);
  if (d.length === 10) return d.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  if (d.length === 11) return d.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  return raw;
};

// 우편번호: 5자리 숫자 (2015년 개편 이후 도로명 우편번호)
export const isValidZip = (zip) => /^\d{5}$/.test((zip || '').trim());

// 기본 주소: 최소 5자 이상, 숫자로만 이루어지지 않아야 함
export const isValidAddress1 = (addr) => {
  const v = (addr || '').trim();
  return v.length >= 5 && !/^\d+$/.test(v);
};

// 비밀번호: 영문 + 숫자 포함 8자 이상
export const PASSWORD_HINT = '영문, 숫자를 포함해 8자 이상';
export const isValidPassword = (pw) => /^(?=.*[A-Za-z])(?=.*\d).{8,}$/.test(pw || '');
